import Vue from 'vue';
import { loadScript } from 'src/util/helper';

window.fbAsyncInit = function() {
	window.FB && window.FB.init({
		appId: process.env.VUE_APP_FACEBOOK_APP_ID,
		xfbml: false,
		version: 'v10.0',
	});
};

const fbReady = loadScript('https://connect.facebook.net/de_DE/sdk.js')
	.catch(console.error);

if (!window.Proxy) window.Proxy = function() {};

Vue.prototype.$fb = window.Proxy && new Proxy({}, {
	get(_, key) {
		return async function(...args) {
			await fbReady;

			if (!window.FB) {
				throw new Error('Error: window.FB is not defined');
			}

			if (!window.FB[key] || !(window.FB[key] instanceof Function)) {
				throw new Error(`Uncaught TypeError: $fb.${key} is not a function`);
			}

			return new Promise((resolve) => {
				const cbi = args.indexOf('cb');
				if (cbi > -1) args[cbi] = resolve;
				else args.push(resolve);
				window.FB[key](...args);
			});
		};
	},
});
